export const scrollToElement = (element) => {
  try {
    element.scrollIntoView({
      behavior: 'smooth'
    })
  } catch(err) {
    console.warn(err)
  }
}

export const scrollToTop = () => {
  document.body.scrollTop = 0 //Safari
  document.documentElement.scrollTop = 0
}